"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IpV4Input = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _shapes = require("../../skybase-core/shapes");

var _sbNonEditableControl = require("../sb-non-editable-control");

var KEY_CODES = _interopRequireWildcard(require("../../skybase-core/constants/keyCodes"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stateFromProps = function stateFromProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 ? arguments[1] : undefined;
  return {
    ip: (0, _utils.updateIp)(state.ip, props.value, props.nullable),
    value: props.value
  };
};

var getClassNames = function getClassNames(classes) {
  return (0, _classnames.default)('sb-control', 'sb-textbox', classes);
}; // Supports both string and array comparison


var isIpUpdated = function isIpUpdated(ip, newIp) {
  return typeof ip === 'string' ? ip !== newIp : !ip.every(function (chunk, key) {
    return chunk === newIp[key];
  });
};
/**
 * @description
 * Component which is helping the user to edit IP-v4 address.
 */


var IpV4Input = /*#__PURE__*/function (_Component) {
  _inherits(IpV4Input, _Component);

  var _super = _createSuper(IpV4Input);

  function IpV4Input(props) {
    var _this;

    _classCallCheck(this, IpV4Input);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "triggerOnChange", function () {
      var onChange = _this.props.onChange;
      var ip = _this.state.ip;

      if (isIpUpdated(_this.oldIp, ip)) {
        // console.log(`IPv4::triggerOnChange called "${this.input.value}"`);
        onChange(_this.input.value, _this.input);
        _this.oldIp = ip;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (evt) {
      var target = evt.target;
      var nullable = _this.props.nullable;
      var _this$state = _this.state,
          ip = _this$state.ip,
          selectionStart = _this$state.selectionStart,
          selectionEnd = _this$state.selectionEnd;
      var checked = (0, _utils.getIPAndPosition)(ip, target.value, (0, _utils.getElementRange)(target), [selectionStart, selectionEnd], nullable);
      _this.oldIp = ip;

      _this.setState({
        ip: checked.updatedIp,
        selectionStart: checked.cursorPosition[0],
        selectionEnd: checked.cursorPosition[1]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputClick", function (_ref) {
      var target = _ref.target;

      // Select current ip chunk when clicked on it. But skip this functionality
      // if there's empty value in input.
      if (target.value !== '') {
        var range = target.selectionStart === target.selectionEnd ? (0, _utils.getRange)(target.value, target.selectionStart) : [target.selectionStart, target.selectionEnd];

        _this.setState({
          selectionStart: range[0],
          selectionEnd: range[1]
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputFocus", function (_ref2) {
      var target = _ref2.target;

      if (!_this.clicked) {
        target.select();
      }

      _this.clicked = false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputMouseDown", function () {
      _this.clicked = true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputKeyDown", function (evt) {
      var target = evt.target,
          keyCode = evt.keyCode;

      if (keyCode === KEY_CODES.tab && target.value.length !== 0) {
        if (evt.shiftKey) {
          var range = (0, _utils.getPreviousRange)(target.value, (0, _utils.getElementRange)(target), true);

          if (range[1] !== 0 || range[0] !== 0) {
            evt.preventDefault();

            _this.setState({
              selectionStart: range[0],
              selectionEnd: range[1]
            });
          } else {
            _this.setState({
              selectionStart: 0,
              selectionEnd: 0
            });
          }
        } else {
          var _range = (0, _utils.getNextRange)(target.value, (0, _utils.getElementRange)(target), true);

          var lastCharacterPosition = target.value.length;

          if (_range[1] !== lastCharacterPosition || _range[0] !== lastCharacterPosition) {
            evt.preventDefault();

            _this.setState({
              selectionStart: _range[0],
              selectionEnd: _range[1]
            });
          } else {
            _this.setState({
              selectionStart: 0,
              selectionEnd: 0
            });
          }
        }
      } else if (keyCode === KEY_CODES.DOT || keyCode === KEY_CODES.NUMPAD_DOT) {
        // skip to the next chunk if the . is pressed and it is the end of a chunk
        var start = target.selectionStart;
        var indexOfDot = target.value.indexOf('.', start);

        if (indexOfDot === start) {
          var _range2 = (0, _utils.getNextRange)(target.value, (0, _utils.getElementRange)(target), true);

          _this.setState({
            selectionStart: _range2[0],
            selectionEnd: _range2[1]
          });
        }

        evt.preventDefault();
      } else {
        //  This corrects input errors caused by the handle input clicks
        _this.setState({
          selectionStart: target.selectionStart,
          selectionEnd: target.selectionEnd
        });
      }
    });

    _this.state = stateFromProps(_this.state, props);
    _this.oldIp = props.value;
    _this.clicked = false;
    return _this;
  } // LifeCycle method to update the IP in the internal state


  _createClass(IpV4Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (document.activeElement !== this.input) {
        return;
      }

      var _this$state2 = this.state,
          selectionStart = _this$state2.selectionStart,
          selectionEnd = _this$state2.selectionEnd;
      this.input.selectionStart = selectionStart;
      this.input.selectionEnd = selectionEnd;
      this.triggerOnChange();
    } // HELPERS

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          editable = _this$props.editable,
          nullable = _this$props.nullable,
          onChange = _this$props.onChange,
          className = _this$props.className,
          id = _this$props.id,
          inputRef = _this$props.inputRef,
          rest = _objectWithoutProperties(_this$props, ["editable", "nullable", "onChange", "className", "id", "inputRef"]);

      var ip = this.state.ip;
      var stringIp = (0, _utils.convertIpToString)(ip);
      /**
       * If editable=false was set, render just converted value.
       */

      if (editable === false) {
        return /*#__PURE__*/_react.default.createElement(_sbNonEditableControl.SbNonEditableControl, {
          value: stringIp,
          inputRef: inputRef,
          id: id,
          className: className
        });
      }

      return /*#__PURE__*/_react.default.createElement("input", _extends({
        type: "text",
        ref: function ref(_ref3) {
          _this2.input = _ref3;
          inputRef(_ref3);
        }
      }, rest, {
        id: id,
        className: getClassNames(className),
        value: stringIp,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onClick: this.handleInputClick,
        onMouseDown: this.handleInputMouseDown,
        onKeyDown: this.handleInputKeyDown
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = stateFromProps(prevState, props);

      if (!(0, _isEqual.default)(newState, prevState)) {
        return {
          value: newState.value
        };
      }

      return null;
    }
  }]);

  return IpV4Input;
}(_react.Component);

exports.IpV4Input = IpV4Input;

_defineProperty(IpV4Input, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  editable: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  nullable: _propTypes.default.bool,
  inputRef: _shapes.PropTypeRef
});

_defineProperty(IpV4Input, "defaultProps", {
  className: null,
  id: null,
  editable: true,
  value: '0.0.0.0',
  nullable: true,
  onChange: function onChange() {},
  inputRef: function inputRef() {}
});
//# sourceMappingURL=ipv4-input.js.map